(() => {
  'use strict';
  if (window.CabaneFiltersDrawer) return;
  const english = () => document.documentElement.lang.toLowerCase().startsWith('en');
  const tr = (fr,en) => english()?en:fr;
  const $ = (s,root=document) => root.querySelector(s);
  const all = (s,root=document) => [...root.querySelectorAll(s)];
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  const button = (cls, text, action) => {
    const n=el('button', cls, text);
    n.type='button';
    n.dataset.action=action;
    return n;
  };
  const number = new Intl.NumberFormat(document.documentElement.lang || 'fr');
  const sizeOrder = new Intl.Collator(document.documentElement.lang || 'fr',{numeric:true,sensitivity:'base'});
  const fold = v => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const resultLabel = n => number.format(n)+(english() ? n===1?' result':' results' : n>1?' résultats':' résultat');
  const currencySymbol = () => new Intl.NumberFormat(document.documentElement.lang || 'fr',{style:'currency',currency:stage?.currency||context?.currency||window.Shopify?.currency?.active||'EUR'}).formatToParts(0).find(p=>p.type==='currency')?.value || '€';
  const isSize = f => /pointure|shoe size|^taille$|^size$/.test(fold(f.label));
  const isBrand = f => /marque|brand/.test(fold(f.label)) || /\.vendor$/.test(f.key);
  const activeEntries = p => [...p].filter(([k,v])=>k.startsWith('filter.') && v!=='');
  const groupId = g => g.viewKey || g.key;
  const isWeight = v => /^\d+(?:[,.]\d+)?\s*(?:kg|g)?$/i.test(String(v).trim());
  const canonical = p => new URLSearchParams(activeEntries(p).sort(([a,x],[b,y])=>a.localeCompare(b)||x.localeCompare(y)));
  let context, universe, draft, stage, status, error, opener;
  let stageRequest, parentEvents, timer, stageEpoch=0, cache;
  let known, openGroups, expanded, queries, priceInput;
  let drawer, head, body, chips, selection, groupsNode, errorNode, live, apply, reset;
  const filterNode = id => all('[data-filter-focus]', drawer).find(n=>n.dataset.filterFocus===id);
  const focusKey = (node,key) => {node.dataset.filterFocus=key;return node;};
  const isModel = data => !!data && Number.isSafeInteger(data.count) && data.count>=0 && Array.isArray(data.facets);
  async function query(p,signal){
    const key=canonical(p).toString();
    if(cache?.key===key && Date.now()-cache.time<30000)return cache.data;
    const data=await window.CabaneFiltersAdapter.query(context,new URLSearchParams(p),signal);
    if(!isModel(data))throw new Error('Invalid catalog facet data');
    if(!signal.aborted)cache={key,time:Date.now(),data};
    return data;
  }
  function remember(facets){
    for(const f of facets){
      if(!f?.key)continue;
      const prev=known.get(f.key), values=new Map(prev?.names || []);
      for(const row of f.values || [])values.set(String(row.value),row);
      known.set(f.key,{...f,names:values});
    }
  }
  function stopStage(){
    stageEpoch++;
    clearTimeout(timer);
    stageRequest?.abort(); stageRequest=null;
  }
  function setStageState(mode,msg=''){
    status=mode;error=msg;drawer.dataset.state=mode;
    const n=stage?.count;
    apply.disabled=mode!=='ready' || !n;
    body.inert=mode==='applying';
    const label={
      loading:tr('Calcul en cours…','Updating…'),invalid:tr('Vérifier les prix','Check prices'),
      error:tr('Résultats indisponibles','Results unavailable'),applying:tr('Application…','Applying…')
    }[mode];
    apply.textContent=label || (!n?tr('Aucun résultat','No results'):tr('Voir ','Show ')+resultLabel(n));
    reset.disabled=mode==='applying' || (!activeEntries(draft).length && ![...priceInput.values()].some(Boolean));
    errorNode.hidden=mode!=='error';
    live.textContent=mode==='loading'?tr('Mise à jour des résultats…','Updating results…'):mode==='invalid'?msg:mode==='error'?tr('Le catalogue ne répond pas. Ta sélection est conservée.','The catalog is unavailable. Your selection is saved.'):
      mode==='applying'?apply.textContent:n===0?tr('Aucun résultat. Retire un critère pour élargir ta recherche.','No results. Remove a filter to broaden your search.'):resultLabel(n);
  }
  function currentFacets(){
    const fresh=new Map((stage?.facets || []).map(f=>[f.key,f]));
    const out=[];
    for(const [key,base] of known){
      const group=fresh.get(key);
      if(!group && stage?.count!==0 && !activeEntries(draft).some(([k])=>[key,base.minKey,base.maxKey].includes(k)))continue;
      const values=new Map((group?.values || []).map(v=>[String(v.value),v]));
      for(const value of draft.getAll(key)){
        if(!values.has(value))values.set(value,{...base.names.get(value),value,label:base.names.get(value)?.label||value,count:0,disabled:false});
      }
      if(!values.size && !group && stage?.count===0)for(const [v,row] of base.names)values.set(v,{...row,count:0,disabled:true});
      const f={...base,...group,values:[...values.values()]};
      if(key==='filter.p.product_type'){
        const kinds=f.values.filter(v=>!isWeight(v.label??v.value)), weights=f.values.filter(v=>isWeight(v.label??v.value));
        if(kinds.length)out.push({...f,label:tr('Type de produit','Product type'),viewKey:key+':type',values:kinds});
        if(weights.length)out.push({...f,label:tr('Poids indiqué','Listed weight'),viewKey:key+':poids',values:weights});
        continue;
      }
      if(universe==='roller' && key==='filter.v.option.taille')f.label=tr('Pointure','Shoe size');
      if(universe==='roller' && key==='filter.v.option.style' && f.values.length && f.values.every(row=>/\d\s*mm\b/i.test(row.label||row.value)))f.label=tr('Diamètre des roues','Wheel diameter');
      if(fold(key)==='filter.v.option.matiere')f.label=tr('Matière & compatibilité','Material & compatibility');
      out.push(f);
    }
    return out;
  }
  function showSelection(){
    chips.replaceChildren();
    const seen=new Set();
    for(const [k,v] of activeEntries(draft)){
      const price=[...known.values()].find(f=>f.type==='price' && [f.minKey,f.maxKey].includes(k));
      const id=price?price.key:k+'='+v;
      if(seen.has(id))continue;seen.add(id);
      let label;
      if(price){
        const min=draft.get(price.minKey),max=draft.get(price.maxKey);
        const symbol=currencySymbol();
        label=min&&max?tr('Prix : ','Price: ')+number.format(min)+'–'+number.format(max)+' '+symbol:min?tr('Dès ','From ')+number.format(min)+' '+symbol:tr('Jusqu’à ','Up to ')+number.format(max)+' '+symbol;
      }else{
        const name=known.get(k)?.names?.get(v)?.label || v;
        if(k==='filter.v.option.taille')label=(universe==='roller'?tr('Pointure ','Shoe size '):tr('Taille ','Size '))+name;
        else if(k==='filter.v.availability')label=v==='1'?tr('En stock','In stock'):v==='0'?tr('En rupture de stock','Out of stock'):name;
        else if(k==='filter.p.product_type' && isWeight(v))label=tr('Poids : ','Weight: ')+name;
        else if(fold(k)==='filter.v.option.matiere' && /^\d/.test(name))label=tr('Dimension : ','Dimension: ')+name;
        else label=name;
      }
      const b=focusKey(button('filter-chip',label,'remove'),'chip:'+id);
      b.append(el('span','filter-chip-cross','×'));
      b.lastChild.setAttribute('aria-hidden','true');
      b.setAttribute('aria-label',tr('Retirer ','Remove ')+label);
      b.dataset.key=k;b.dataset.value=v;if(price)b.dataset.price=price.key;
      chips.append(b);
    }
    selection.hidden=!seen.size;
    $('.filter-selection-label',selection).textContent=tr('Ta sélection (','Your selection (')+seen.size+')';
  }
  function swatch(raw){
    let c=String(raw||'').trim();
    if(!c)return '';
    if(/^#[0-9a-f]{3,8}$/i.test(c)||/^rgba?\([\d\s.,%/]+\)$/i.test(c))return c;
    if(/^(linear|conic)-gradient\([\s\d.,%#a-fdeg()]+\)$/i.test(c) && CSS.supports('background-image',c))return c;
    return '';
  }
  function option(label,group,row){
    const value=String(row.value),checked=draft.getAll(group.key).includes(value), disabled=!checked && (row.disabled===true||row.count===0);
    const wrapper=el('label','filter-option'+(checked?' is-active':''));
    const checkbox=focusKey(el('input'),'option:'+group.key+'/'+value);
    checkbox.type='checkbox'; checkbox.checked=checked; checkbox.disabled=disabled;
    checkbox.dataset.filterKey=group.key;checkbox.value=value;
    wrapper.append(checkbox);
    if(group.type==='color'){
      const dot=el('span','filter-swatch');
      dot.setAttribute('aria-hidden','true');
      const color=swatch(row.color);
      if(color)dot.style.background=color;else dot.classList.add('is-unknown');
      wrapper.append(dot);
    }
    wrapper.append(el('span','filter-option-text',label));
    if(Number.isFinite(row.count))wrapper.append(el('small','filter-count',number.format(row.count)));
    return wrapper;
  }
  function compactSizes(rows){
    const suggested=new Set();
    const available=rows.filter(row=>!row.disabled && row.count!==0);
    const ranges=available.filter(row=>/^\d+(?:[.,]\d+)?\s*[-–—/]\s*\d+/.test(row.label??row.value));
    const regular=available.filter(row=>/^\d+$/.test(row.label??row.value));
    if(ranges.length && regular.length){
      suggested.add(ranges[0]);
      suggested.add(ranges[Math.floor((ranges.length-1)/2)]);
      for(const size of ['38','39','40','41']){
        const row=regular.find(r=>String(r.label??r.value)===size);
        if(row)suggested.add(row);
      }
      const other=regular.filter(row=>!suggested.has(row));
      const slots=Math.min(6-suggested.size,other.length);
      for(let i=0;i<slots;i++)suggested.add(other[Math.round(i*(other.length-1)/Math.max(1,slots-1))]);
    }
    for(const row of [...available,...rows]){
      if(suggested.size>=6)break;
      suggested.add(row);
    }
    return suggested;
  }
  function paintRows(group, container){
    const term=fold(queries.get(group.key)).trim();
    const isPointure=universe==='roller' && isSize(group);
    const rows=group.values.filter(v=>{
      const label=fold(v.label??v.value);
      if(!isPointure || !/^\d{2}(?:[.,]\d+)?$/.test(term))return label.includes(term);
      const range=label.match(/^\s*(\d+(?:[.,]\d+)?)(?:\s*[-–—/]\s*(\d+(?:[.,]\d+)?))?/);
      if(!range)return false;
      const shoeSize=Number(term.replace(',','.')), a=Number(range[1].replace(',','.')), b=range[2]?Number(range[2].replace(',','.')):a;
      return shoeSize>=Math.min(a,b) && shoeSize<=Math.max(a,b);
    });
    if(isSize(group))rows.sort((a,b)=>sizeOrder.compare(String(a.label??a.value),String(b.label??b.value)));
    const id=groupId(group), chosen=new Set(draft.getAll(group.key)), show=expanded.has(id)||!!term;
    const unavailable = row => !chosen.has(String(row.value)) && (row.disabled || row.count===0);
    rows.sort((a,b)=>Number(Boolean(unavailable(a)))-Number(Boolean(unavailable(b))));
    const compact=isPointure&&!show?compactSizes(rows):null;
    const visible=show?rows:rows.filter((row,i)=>(compact?compact.has(row):i<6) || chosen.has(String(row.value)));
    const content=visible.map(r=>option(r.label??String(r.value),group,r));
    if(!content.length)content.push(el('p','filter-empty',tr('Aucune valeur correspondante.','No matching options.')));
    if(rows.length>6 && !term){
      const remaining=rows.length-visible.length;
      if(show || remaining){
        const b=focusKey(button('filter-more',show?tr('Afficher moins','Show less'):isPointure?tr('Voir les ','See all ')+number.format(rows.length)+tr(' pointures',' shoe sizes'):tr('Afficher ','Show ')+number.format(remaining)+tr(' de plus',' more'),'more'),'more:'+id);
        b.dataset.key=id; b.setAttribute('aria-expanded',String(show)); content.push(b);
      }
    }
    container.replaceChildren(...content);
  }
  function priceFields(group){
    const wrap=el('div','filter-price');
    for(const [key,name] of [[group.minKey,tr('De','From')],[group.maxKey,tr('À','To')]]){
      if(!key)continue;
      const label=el('label','filter-price-label');label.append(el('span',null,name+' ('+currencySymbol()+')'));
      const input=focusKey(el('input'),'price:'+key);
      input.type='text';input.inputMode='decimal';input.autocomplete='off';
      input.value=priceInput.get(key) ?? draft.get(key) ?? '';
      input.placeholder=String(key===group.minKey?0:group.limit??'');
      input.dataset.priceKey=key;
      input.setAttribute('aria-describedby','CabaneFilterPriceError');
      label.append(input);wrap.append(label);
    }
    const msg=el('p','filter-price-error');
    msg.id='CabaneFilterPriceError';msg.hidden=status!=='invalid';msg.textContent=status==='invalid'?error:'';
    wrap.append(msg);
    return wrap;
  }
  function selectedCount(group){
    if(group.type==='price')return Number(!!(draft.get(group.minKey)||draft.get(group.maxKey)));
    const selected=new Set(draft.getAll(group.key));
    return group.values.filter(v=>selected.has(String(v.value))).length;
  }
  function facet(group){
    const id=groupId(group),d=el('details','filter-group');d.dataset.group=id;
    const summary=focusKey(el('summary'),'summary:'+id);
    summary.append(el('span','filter-group-label',group.label));
    const total=selectedCount(group);
    if(total)summary.append(el('span','filter-summary-meta',String(total)));
    d.append(summary);
    if(group.type==='price')d.append(priceFields(group));
    else{
      const wrap=el('div','filter-group-body');
      const searchLabel=isBrand(group);
      const sizeSearch=universe==='roller' && isSize(group);
      if((searchLabel || sizeSearch) && (group.values.length>(sizeSearch?10:8)||queries.has(group.key))){
        const label=el('label','filter-search');
        const prompt=sizeSearch?tr('Trouver ma pointure','Find my shoe size'):tr('Rechercher une marque','Search brands');
        label.append(el('span','filter-sr-only',prompt));
        const input=focusKey(el('input'),'search:'+group.key);
        input.type='search';input.autocomplete='off';input.placeholder=prompt;input.dataset.searchKey=group.key;input.value=queries.get(group.key)||'';
        if(sizeSearch)input.inputMode='decimal';
        label.append(input);wrap.append(label);
      }
      const rows=el('div','filter-options');
      if(isSize(group))rows.classList.add('filter-options--sizes');
      if(group.type==='color')rows.classList.add('filter-options--colors');
      paintRows(group,rows);wrap.append(rows);d.append(wrap);
    }
    d.open=openGroups.has(id);
    return d;
  }
  function rank(group){
    const label=fold(group.label);
    if(universe==='roller' && isSize(group))return 0;
    if(isBrand(group))return 1;
    if(/pratique|practice|discipline/.test(label))return 2;
    if(/disponibil|availab/.test(label))return 3;
    if(group.type==='price')return 4;
    if(group.type==='color'||/couleur/.test(label))return 5;
    if(/taille|diametre|niveau/.test(label))return 6;
    return 8;
  }
  function paintGroups(){
    const scroll=body.scrollTop, active=document.activeElement, id=active?.dataset.filterFocus;
    const start=id && typeof active.selectionStart==='number'?active.selectionStart:null;
    const end=start!=null?active.selectionEnd:null;
    const items=currentFacets().sort((a,b)=>rank(a)-rank(b));
    // Default applies once on opening. User choices persist across refreshes.
    if(openGroups.size===0 && !drawer.dataset.groupsInitialized && items.length){
      openGroups.add(groupId(items[0])); drawer.dataset.groupsInitialized='1';
    }
    const primary=[],secondary=[],names=new Set();
    for(const item of items){
      const name=fold(item.label).replace(/\s*\([^)]*\)\s*$/,'');
      const isExtra=primary.length>=6 || names.has(name) || /tranche/.test(fold(item.label)) ||
        (rank(item)>=8 && primary.length>=4);
      (isExtra?secondary:primary).push(item);names.add(name);
    }
    const nodes=primary.map(facet);
    if(secondary.length){
      const extra=el('details','filter-group filter-more-groups');
      extra.dataset.group='other';
      const title=focusKey(el('summary'),'summary:other');
      title.append(el('span','filter-group-label',tr('Autres filtres','More filters')));
      const count=secondary.reduce((n,g)=>n+selectedCount(g),0);
      if(count)title.append(el('span','filter-summary-meta',String(count)));
      extra.append(title,...secondary.map(facet));
      extra.open=openGroups.has('other');nodes.push(extra);
    }
    if(!nodes.length)nodes.push(el('p','filter-empty',status==='loading'?tr('Chargement des filtres…','Loading filters…'):tr('Aucun autre filtre disponible.','No additional filters available.')));
    groupsNode.replaceChildren(...nodes);
    if(id){
      const replacement=filterNode(id);
      if(replacement && !replacement.disabled){replacement.focus({preventScroll:true});if(start!=null && replacement.setSelectionRange)replacement.setSelectionRange(start,end);}
    }
    body.scrollTop=scroll;
    showSelection();
  }
  function parsePrice(value){
    if(!value.trim())return '';
    const clean=value.trim().replace(/\s/g,'').replace(',','.');
    if(!/^\d+(\.\d{1,2})?$/.test(clean) || !Number.isFinite(Number(clean)))return null;
    return String(Number(clean));
  }
  function validatePrices(){
    const group=[...known.values()].find(f=>f.type==='price');
    if(!group)return '';
    const keys=[group.minKey,group.maxKey], values=keys.map(k=>parsePrice(priceInput.get(k)??draft.get(k)??''));
    let msg='';
    if(values.includes(null))msg=tr('Entre un prix positif, avec au plus deux décimales.','Enter a positive price with up to two decimals.');
    else if(values[0] && values[1] && Number(values[0])>Number(values[1]))msg=tr('Le prix maximum doit être supérieur ou égal au minimum.','The maximum must be greater than or equal to the minimum.');
    for(const input of all('[data-price-key]',drawer))input.setAttribute('aria-invalid',String(!!msg));
    const errorLabel=$('.filter-price-error',drawer);
    if(errorLabel){errorLabel.textContent=msg;errorLabel.hidden=!msg;}
    if(!msg)keys.forEach((k,i)=>{if(values[i])draft.set(k,values[i]);else draft.delete(k);});
    return msg;
  }
  function refreshDraft(delay=0){
    stopStage();
    const epoch=stageEpoch,msg=validatePrices();
    if(msg){setStageState('invalid',msg);return;}
    showSelection();
    setStageState('loading');
    timer=setTimeout(async()=>{
      try{
        const controller=stageRequest=new AbortController();
        const data=await query(draft, controller.signal);
        if(epoch!==stageEpoch || !drawer.open)return;
        stage=data;remember(data.facets);
        setStageState('ready');paintGroups();
      }catch(err){
        if(epoch!==stageEpoch || err.name==='AbortError')return;
        setStageState('error');
      }
    },delay);
  }
  function closeDrawer(restoreFocus=true){
    if(!drawer?.open)return;
    stopStage();
    parentEvents?.abort();
    const previous=context,previousOpener=opener;
    previousOpener?.setAttribute('aria-expanded','false');
    context=null;cache=null;
    drawer.close();
    document.documentElement.classList.remove('cabane-filter-drawer-open');
    if(restoreFocus){
      if(previousOpener?.isConnected && previousOpener.getClientRects().length)previousOpener.focus({preventScroll:true});
      else window.CabaneFiltersAdapter?.focus?.(previous);
    }
  }
  async function commit(){
    if(status!=='ready' || !stage?.count)return;
    // Reselect the committed state without making a second navigation.
    if(canonical(draft).toString()===canonical(new URLSearchParams(context.params)).toString()){closeDrawer();return;}
    stopStage();
    const epoch=stageEpoch,controller=stageRequest=new AbortController();
    setStageState('applying');
    try{
      await window.CabaneFiltersAdapter.apply(context,new URLSearchParams(draft),stage,controller.signal);
      if(epoch===stageEpoch && drawer.open)closeDrawer();
    }catch(err){
      if(epoch===stageEpoch && err?.name!=='AbortError' && drawer.open)setStageState('error');
    }
  }
  function openDrawer(trigger,selectedContext){
    if(drawer?.open)return true;
    if(!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal)return false;
    const adapter=window.CabaneFiltersAdapter;
    const next=selectedContext||adapter?.context(trigger);
    if(!next)return false;
    ensureDrawer();
    opener=trigger;context=next;universe=next.discipline || 'catalog';
    draft=canonical(new URLSearchParams(next.params));stage=isModel(next.initial)?next.initial:null;
    cache=null;known=new Map();openGroups=new Set();expanded=new Set();queries=new Map();priceInput=new Map();
    delete drawer.dataset.groupsInitialized;
    if(stage)remember(stage.facets);
    $('.filter-eyebrow',head).textContent=next.title || tr('Le catalogue','The catalog');
    // A separate top-layer dialog keeps its events outside the search overlay.
    const parent=trigger?.closest('dialog[open]');
    if(drawer.parentElement!==document.body)document.body.append(drawer);
    if(parent){
      parentEvents=new AbortController();
      parent.addEventListener('close',()=>{if(!parent.open)closeDrawer(false);},{signal:parentEvents.signal});
    }
    opener?.setAttribute('aria-haspopup','dialog');
    opener?.setAttribute('aria-controls',drawer.id);
    opener?.setAttribute('aria-expanded','true');
    drawer.showModal();
    document.documentElement.classList.add('cabane-filter-drawer-open');
    body.scrollTop=0;
    $('.filter-close',drawer).focus({preventScroll:true});
    setStageState(stage?'ready':'loading');paintGroups();
    if(!stage)refreshDraft();
    return true;
  }
  function ensureDrawer(){
    if(drawer?.isConnected)return;
    drawer=el('dialog','filter-sheet');
    drawer.dataset.cabaneFilterDrawer='';
    drawer.id='CabaneLiveFilterDrawer';
    drawer.setAttribute('aria-labelledby','CabaneLiveFilterHeading');
    head=el('header','filter-head');
    const titles=el('div');
    const title=el('h2','filter-title',tr('Filtrer ','Filter '));title.append(el('span',null,tr('les produits.','products.')));title.id='CabaneLiveFilterHeading';
    titles.append(el('p','filter-eyebrow'),title);
    const close=button('filter-close','','close');close.setAttribute('aria-label',tr('Fermer les filtres','Close filters'));
    close.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
    head.append(titles,close);
    body=el('div','filter-body');selection=el('section','filter-selection');chips=el('div','filter-chips');
    selection.append(el('p','filter-selection-label'),chips);groupsNode=el('div','filter-groups');
    errorNode=el('div','filter-error');errorNode.hidden=true;
    errorNode.append(el('p',null,tr('Le catalogue ne répond pas. Ta sélection est conservée.','The catalog could not be updated. Your selection is saved.')),button('filter-more',tr('Réessayer','Try again'),'retry'));
    body.append(selection,groupsNode,errorNode);
    const foot=el('footer','filter-foot');
    live=el('p','filter-live filter-sr-only');live.setAttribute('role','status');live.setAttribute('aria-live','polite');
    apply=button('filter-apply',tr('Voir les résultats','Show results'),'apply');reset=button('filter-reset',tr('Tout effacer','Clear all'),'reset');foot.append(apply,reset,live);
    drawer.replaceChildren(head,body,foot);
    drawer.addEventListener('cancel',event=>{event.preventDefault();closeDrawer();});
    drawer.addEventListener('close',event=>{
      if(event.target!==drawer || drawer.open || !context)return;
      stopStage();parentEvents?.abort();context=null;cache=null;
      opener?.setAttribute('aria-expanded','false');
      document.documentElement.classList.remove('cabane-filter-drawer-open');
    });
    drawer.addEventListener('toggle',e=>{
      const group=e.target.dataset?.group;
      if(!group || !drawer.contains(e.target))return;
      if(e.target.open)openGroups.add(group);else openGroups.delete(group);
    },true);
    drawer.addEventListener('input',e=>{
      const input=e.target;
      if(input.dataset.searchKey){
        queries.set(input.dataset.searchKey,input.value);
        const group=currentFacets().find(g=>g.key===input.dataset.searchKey);
        if(group)paintRows(group,$('.filter-options',input.closest('details')));
      }else if(input.dataset.priceKey){
        priceInput.set(input.dataset.priceKey,input.value);
        refreshDraft(260);
      }
    });
    drawer.addEventListener('change',e=>{
      const input=e.target,key=input.dataset.filterKey;
      if(!key)return;
      if(input.checked && !draft.getAll(key).includes(input.value))draft.append(key,input.value);
      else if(!input.checked)draft.delete(key,input.value);
      input.closest('label').classList.toggle('is-active',input.checked);
      refreshDraft(90);
    });
    drawer.addEventListener('click',e=>{
      const b=e.target.closest('button');
      if(!b){
        if(e.target===drawer){const r=drawer.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom){closeDrawer();}}
        return;
      }
      switch(b.dataset.action){
        case 'close': closeDrawer();break;
        case 'more': {
          const key=b.dataset.key,group=currentFacets().find(g=>groupId(g)===key);
          if(expanded.has(key))expanded.delete(key);else expanded.add(key);
          if(group){paintRows(group,$('.filter-options',b.closest('details')));filterNode('more:'+key)?.focus({preventScroll:true});}
          break;
        }
        case 'remove': {
          if(b.dataset.price){
            const g=known.get(b.dataset.price);
            if(g)for(const k of [g.minKey,g.maxKey]){draft.delete(k);priceInput.delete(k);}
          }else draft.delete(b.dataset.key,b.dataset.value);
          paintGroups(); (chips.querySelector('button') || $('.filter-close',drawer)).focus({preventScroll:true});
          refreshDraft();break;
        }
        case 'reset': draft=new URLSearchParams();priceInput.clear();queries.clear();expanded.clear();paintGroups();refreshDraft();break;
        case 'retry': refreshDraft();break;
        case 'apply': commit();break;
      }
    });
  }
  // Before theme-level document handlers open a legacy <details>. If the
  // adapter doesn't recognize the trigger, the native behavior stays intact.
  window.addEventListener('click',event=>{
    if(event.defaultPrevented || event.button!==0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || drawer?.contains(event.target))return;
    const adapter=window.CabaneFiltersAdapter;
    const trigger=adapter?.triggerFor(event.target);
    if(!trigger)return;
    const selected=adapter.context(trigger);
    if(!selected || !openDrawer(trigger,selected))return;
    event.preventDefault();event.stopImmediatePropagation();
  },true);
  window.addEventListener('keydown',event=>{
    if(!drawer?.open || event.key!=='Escape' || event.isComposing)return;
    event.preventDefault();event.stopImmediatePropagation();closeDrawer();
  },true);
  const openerSelector='[data-cabane-filter-toggle], [data-cs-filters]';
  function armTrigger(trigger){
    const adapter=window.CabaneFiltersAdapter;
    if(!adapter?.triggerFor(trigger))return;
    const scope=trigger.closest('[data-cs-results], .cabane-sidebar-filters');
    if(!scope || trigger.closest('#main-collection-filters') || scope.querySelector('.cabane-filter-sheet:modal, .cs-filters:modal'))return;
    scope.dataset.cabaneFilterEnhanced='';
    trigger.setAttribute('aria-haspopup','dialog');
    const expanded=String(!!drawer?.open && trigger===opener);
    if(trigger.getAttribute('aria-expanded')!==expanded)trigger.setAttribute('aria-expanded',expanded);
    if(drawer?.isConnected)trigger.setAttribute('aria-controls',drawer.id);
  }
  function armAll(){
    if(!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal || !window.CabaneFiltersAdapter)return;
    all(openerSelector).forEach(armTrigger);
  }
  function watchStorefront(){
    if(!document.body || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal)return;
    armAll();
    const observer=new MutationObserver(changes=>{
      for(const change of changes){
        if(change.type==='attributes'){
          if(change.target.matches(openerSelector))armTrigger(change.target);
        }else for(const node of change.addedNodes){
          if(node.nodeType!==1 || drawer?.contains(node))continue;
          if(node.matches(openerSelector))armTrigger(node);
          else node.querySelectorAll(openerSelector).forEach(armTrigger);
        }
      }
    });
    observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-expanded']});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watchStorefront,{once:true});else watchStorefront();
  document.addEventListener('shopify:section:load',armAll);
  document.addEventListener('cabane:catalog-updated',armAll);
  document.addEventListener('toggle',event=>{if(event.target.matches?.('dialog.cs[open]'))armAll();},true);
  window.addEventListener('popstate',()=>closeDrawer(false),true);
  window.addEventListener('pagehide',()=>closeDrawer(false));
  document.addEventListener('cabane:catalog-before-navigation',()=>{if(status!=='applying')closeDrawer(false);});
  document.addEventListener('shopify:section:unload',event=>{
    if(drawer?.open && event.target.contains?.(drawer))closeDrawer(false);
  });
  window.CabaneFiltersDrawer={open:openDrawer,close:closeDrawer};
})();
